import { createContext } from 'react';
import { settings } from 'config';

const AppContext = createContext(settings);

export const ChatContext = createContext({
  conversations: [],
  getConversations: () => {},
  activeConversationId: null,
  setActiveConversationId: () => {},

  sendMessage: () => {},
  readMessages: () => {},

  textAreaInitialHeight: 0,
  setTextAreaInitialHeight: () => {},

  isOpenConversationInfo: false,
  setIsOpenConversationInfo: () => {},

  conversation: null,
  getConversation: () => {},
  deleteConversation: () => {},

  scrollToBottom: false,
  setScrollToBottom: () => {},

  searchInConversations: () => {},
  isSearchConversation: false,
  setIsSearchConversation: () => {},

  scrollToMessage: null,
  setScrollToMessage: () => {},

  isLoading: false,
  setIsLoading: () => {},

  currentUserName: {},

  neighborhoodsObj: {}
});

export const PropertyWizardContext = createContext({
  handleSubmit: () => {},
  yupSubmitRef: null,
  step: 1,
  setStep: () => {},
  data: {},
  setData: () => {},
  stepStatus: {},
  setStepStatus: () => {},
  setAction: () => {},
  handleNavs: () => {},
  formReset: false,
  status: null,
  form: null,
  types: []
});

export const ProjectWizardContext = createContext({
  handleSubmit: () => {},
  yupSubmitRef: null,
  step: 1,
  setStep: () => {},
  data: {},
  setData: () => {},
  stepStatus: {},
  setStepStatus: () => {},
  setAction: () => {},
  handleNavs: () => {},
  formReset: false,
  status: null,
  form: null,
  types: []
});

export default AppContext;
